<template>
  <div>
    <mdb-card class="mb-4">
      <mdb-card-header>{{ capitalize($tc('common.label.group',1)) }} Rating</mdb-card-header>
      <mdb-card-body v-if="error">
        <error :error="error"/>
      </mdb-card-body>
      <mdb-card-body class="text-center" v-if="ratingData">
        <h4>Overall Rating</h4>
        <mdb-rating disabled v-model="groupRating"/>
        <div class="mb-3" v-if="group.currentMember && !publicView">
          <h4>My Rating</h4>
          <mdb-rating v-model="myCurrentRating"/>
          <mdb-btn @click.native="reviewModal = true" color="default">My Review
            <mdb-icon class="ml-1" icon="eye"/>
          </mdb-btn>
        </div>
        <div v-if="ratingData.reviewCount > 0">
          <router-link :to="'/group/'+group.vanityPath+'/review/'">Read Reviews</router-link>
        </div>
        <mdb-modal :show="reviewModal" @close="reviewModal = false">
          <mdb-modal-header class="text-center">
            <mdb-modal-title bold class="w-100" tag="h4">Review of {{ group.name }}</mdb-modal-title>
          </mdb-modal-header>
          <mdb-modal-body class="mx-3 grey-text">
            <mdb-input icon="pencil-alt" label="Your Review" type="textarea" v-model="ratingData.myReview"/>
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn @click.native="updateReview" color="unique" v-if="ratingData.myReview">Send
              <mdb-icon class="ml-1" icon="paper-plane"/>
            </mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbModalTitle,
  mdbRating,
  mdbTextarea
} from 'mdbvue';

export default {
  name: 'imageSection',
  components: {
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbRating,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbInput,
    mdbModalFooter,
    mdbTextarea,
    mdbIcon,
    mdbModalTitle
  },
  props: {
    group: {
      type: Object,
      default: null
    },
    section: {
      type: Object,
      default: null
    }
  },
  computed: {
    settings() {
      return this.$store.state.settings
    },
  },
  data() {
    return {
      ratingData: null,
      error: null,
      myCurrentRating: null,
      groupRating: null,
      reviewModal: false,
      publicView: false
    };
  },
  watch: {
    myCurrentRating: function (newVal, oldVal) {
      if (oldVal != null && oldVal != newVal) {
        this.$store.dispatch("setExecuting", true)
        api.post("/member/rating/" + this.group.vanityPath, {rating: newVal}).then(
          (results) => {
            this.$store.dispatch("setExecuting", false)
            this.$notify.success({message: "Thanks for the feedback!", timeOut: 5000, position: 'top center'})
          },
          (error) => {
            this.$store.dispatch("setExecuting", false)
            this.$notify.error({
                                 message: "Your rating could not be saved. Please try again later.",
                                 timeOut: 5000,
                                 position: 'top center'
                               })
          })
      }
    }
  },
  mounted() {
    if (this.$route.query.viewAs == "Public") this.publicView = true
    if (!this.group) {
      return
    }
    this.ratingData = this.section.data
    this.myCurrentRating = this.section.data.myRating
    this.groupRating = this.section.data.avgRating

  },
  methods: {
    updateReview: function () {
      this.$store.dispatch("setExecuting", true)
      this.reviewModal = false
      api.post("/member/review/" + this.group.vanityPath, {review: this.ratingData.myReview}).then(
        (results) => {
          this.$store.dispatch("setExecuting", false)
          this.$notify.success({message: "Thanks for your review!", timeOut: 5000, position: 'top center'})
        },
        (error) => {
          this.$store.dispatch("setExecuting", false)
          this.$notify.error({
                               message: "There was a problem saving your review. Please try again later.",
                               timeOut: 5000,
                               position: 'top center'
                             })
        });

    },
  }
};
</script>
